import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';

import theme from '../styles/theme';
import AuthProvider from '../components/Context/AuthContext';
import ModalProvider from '../components/Context/ModalContext';
import SnackbarProvider from '../components/Context/SnackbarContext';
import MessagesProvider from '../components/Context/MessagesContext';

const Providers: React.FC = ({ children }) => (
  <ThemeProvider theme={theme}>
    <MessagesProvider>
      <SnackbarProvider>
        <ModalProvider>
          <AuthProvider>{children}</AuthProvider>
        </ModalProvider>
      </SnackbarProvider>
    </MessagesProvider>
  </ThemeProvider>
);

export default Providers;
